import React from 'react';
import i18next from 'i18next';
import { Row, Col, Card, CardBody, Button} from 'reactstrap';
import Spinner from '../shared/spinner';
import BackOfficeSerivce from '../../services/backOffice.service';
import UtilsService from '../../services/utils/utils.service';
import NoData from '../shared/noData';
import TermsAndConditionsFooter from '../terms-and-conditions/footer';
import axios from "axios";
import CoreService from '../../services/utils/core.service';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import CancellationsStore from './cancellationsFilters.store';
import CancellationTable from './cancellations.table';

export default class Cancellations extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            showBackOfficeError: false,
            showExportError: false,
            showExportQueueMessage: false,

            openedIndexes: [],
            data: null,
            pageNumber: 1,
            periods: [],
        }
    }

    componentDidMount() {
        // Get dataprovider
        return BackOfficeSerivce
            .getDateperiods({
                target: 'cancellations'
            })
            .then(periods => {
                this.setState({
                    periods: periods
                });
            })
            .catch((error) => {
                if (error.errorCodes && error.errorCodes.indexOf('BACK_OFFICE_ERROR') >= 0) {
                    this.setState({
                        showBackOfficeError: true
                    });
                }
            })
            .finally(() => {
                // Start
                this._realodData();
            });
    }

    toggleCollapse = (index) => {
        // Toggle index
        let openedIndexes = this.state.openedIndexes;
        let k = openedIndexes.indexOf(index);
        if (k < 0) {
            openedIndexes.push(index);
        } else {
            openedIndexes.splice(k, 1);
        }

        this.setState({
            openedIndexes: openedIndexes
        });
    }

    isCollapseOpen(index) {
        return this.state.openedIndexes.indexOf(index) >= 0;
    }

    clearFilters = () => {
        CancellationsStore.clearFilters();
        this.setState({
            openedIndexes: []
        });

        this._realodData();
    }

    realod = () => {
        let index = CancellationsStore.openedIndexes.length ?
        CancellationsStore.openedIndexes[0] :
            null;

        this._realodData(index);
    }

    onPeriodChange = (ref) => {
        // Clear opened indexes
        this.setState({
            openedIndexes: []
        });

        const period = this.state.periods.find(_ => _.ref == ref);

        // Period
        let from = period.startDate;
        let to = period.endDate;

        CancellationsStore.setFilter({
            from,
            to,
            agent: '',
            account: '',
            instrument: '',
            period: ref,
        });

        this._realodData();
    }

    /**
     * Export to Excel
     */
    exportToExcel = () => {
        let params = this._getFilter();
        params.lang = i18next.language;
        let url = `${window.apiUrl}/api/BackOffice/cancellations-export`;
        url = UtilsService.addParamsToUrl(url, params);

        // Axios config
        let config = CoreService.getAxiosConfig();

        // Show loading
        this.setState({
            isLoading: true,
            showExportError: false
        });

        // Axios request
        axios
            .get(encodeURI(url), config)

            .then(response => {
                var r = response.data;

                if(r.httpCode == 200 && r.data) {
                    // Check response type
                    if(r.data.type == 'queue') {
                        // Show message
                        this.setState({
                            showExportQueueMessage: true
                        });
                    } else {
                        // Error
                        this.setState({
                            showExportError: true
                        });
                    }
                } else {
                    // Error
                    this.setState({
                        showExportError: true
                    });
                }
            })

            .catch((error) => {
                this.setState({
                    showExportError: true
                });
            })

            .finally(() => {
                this.setState({
                    isLoading: false
                });
            })
        ;
    }

    hideExportQueueMessage = () => {
        this.setState({
            showExportQueueMessage: false
        });
    }

    onPageChange = (pageNumber) => {
        this.state.pageNumber = pageNumber;
        this._getItems();
    }

    render() {
        return (
            <React.Fragment>
                <div className="cancellations pb-3">
                    
                <Card>
                        <CardBody>
                            {
                                CancellationsStore.isSomeFilter ?
                                    <div className="clear-filters">
                                        <Button
                                            type="button"
                                            color="link"
                                            onClick={this.clearFilters}>
                                            {i18next.t('CLEAR_FILTERS')}
                                        </Button>
                                    </div> :
                                    null
                            }
                            <Row className="mb-4 align-items-end">
                                <Col xs="2">
                                    <label>{i18next.t('PERIOD')}:</label>
                                    <select className="form-control"
                                        value={CancellationsStore.filter.period}
                                        onChange={(e) => { 
                                            this.onPeriodChange(e.target.value)
                                        }}
                                    >
                                        { this.state.periods.map((item, index) =>
                                            <option key={index} value={item.ref}>{item.label}</option>
                                        ) }
                                    </select>
                                </Col>
                                <Col xs="2">
                                    <label>{i18next.t('AGENT')}:</label>
                                    <select className="form-control"
                                        value={CancellationsStore.filter.agent}
                                        onChange={(e) => { CancellationsStore.setFilterProp('agent', e.target.value); this._getItems() }}
                                    >
                                        <option value=''>-{i18next.t('ALL')}-</option>
                                        {this.state.data && this.state.data.agents && this.state.data.agents.map((item, index) =>
                                            <option key={index} value={item.clearingMemberCode}>{item.friendlyName}</option>
                                        )}
                                    </select>
                                </Col>
                                <Col xs="2">
                                    <label>{i18next.t('ACCOUNT')}:</label>
                                    <select className="form-control"
                                        value={CancellationsStore.filter.account}
                                        onChange={(e) => { CancellationsStore.setFilterProp('account', e.target.value); this._getItems() }}
                                    >
                                        <option value=''>-{i18next.t('ALL')}-</option>
                                        {this.state.data && this.state.data.accounts && this.state.data.accounts.map((item, index) =>
                                            <option key={index} value={item.accountCode}>{item.friendlyName}</option>
                                        )}
                                    </select>
                                </Col>
                                <Col xs="2">
                                    <label>{i18next.t('CURRENCY_SYMBOL')}:</label>
                                    <select className="form-control"
                                        value={CancellationsStore.filter.currency}
                                        onChange={(e) => { CancellationsStore.setFilterProp('currency', e.target.value); this._getItems() }}
                                    >
                                        <option value=''>-{i18next.t('ALL')}-</option>
                                        {this.state.data && this.state.data.currencies && this.state.data.currencies.map((item, index) =>
                                            <option key={index} value={item.currency}>{UtilsService.translateCurrencySymbol(item.currency)}</option>
                                        )}
                                    </select>
                                </Col>
                                <Col xs="2">
                                    <label>{i18next.t('INSTRUMENT')}:</label>
                                    <select className="form-control"
                                        value={CancellationsStore.filter.instrument}
                                        onChange={(e) => { CancellationsStore.setFilterProp('instrument', e.target.value); this._getItems() }}
                                    >
                                        <option value=''>-{i18next.t('ALL')}-</option>
                                        {this.state.data && this.state.data.instruments && this.state.data.instruments.map((item, index) =>
                                            <option key={index} value={item.instrumentId}>{item.symbol}</option>
                                        )}
                                    </select>
                                </Col>
                                <Col className="text-right">
                                    <Button
                                        type="button"
                                        outline
                                        color="primary"
                                        size="sm"
                                        onClick={this.realod}>
                                        {i18next.t('REALOAD')}
                                    </Button>
                                </Col>
                            </Row>

                            <div className="mb-4 text-right">
                                <button type="button" className="btn btn-primary" onClick={this.exportToExcel}>
                                    <i className="fa fa-file-pdf-o mr-2"></i>
                                    {i18next.t('DOWNLOAD_XLSX')}
                                </button> 

                                { this.state.showExportError ? 
                                    <p className="pt-2">
                                        {i18next.t('DOWNLOAD_XLSX_ERROR')}
                                    </p> 
                                    : null }
                            </div>

                            {this.state.data && this.state.data.businessUnits.map((h, index) => {
                                return (
                                    <CancellationTable
                                        index={index}
                                        h={h}
                                        items={h.items || []}
                                        page={this.state.data.pageNumber}
                                        totals={h.totals}
                                        total={h.registersNumber}
                                        onChange={(pageNumber) => this.onPageChange(pageNumber)}
                                    />
                                );
                            })}

                            {!!this.state.showBackOfficeError ?
                                <NoData imgSrc="/assets/img/no-internet.svg" msg={`${i18next.t('CANT_SHOW_DATA_ATM')}`} /> :
                                (!this.state.isLoading && (this.state.data && !this.state.data.businessUnits.length)) ?
                                    <NoData msg={`${i18next.t('NO_DATA_WITH_DATE_RANGE')}: ${UtilsService.dateFormat(CancellationsStore.filter.from)} - ${UtilsService.dateFormat(CancellationsStore.filter.to)}`} /> :
                                    null
                            }
                        </CardBody>

                        {this.state.isLoading && <Spinner />}
                    </Card>

                    {(this.state.data && this.state.data.businessUnits.length) ? <TermsAndConditionsFooter /> : null}

                </div>

                { this.state.showExportQueueMessage ? 
                    <Modal isOpen={true} backdrop={true}>
                        <ModalHeader>{i18next.t('EXPORT_QUEUE')}</ModalHeader>
                        <ModalBody>
                            <div>
                                <p>{i18next.t('EXPORT_QUEUE_MESSAGE')}</p>

                                <div className="text-right d-flex align-items-center justify-content-end mr-2">
                                    <button type="button" 
                                        className="btn btn-primary btn-sm mr-2"
                                        onClick={this.hideExportQueueMessage}
                                        style={{
                                            'backgroundColor': '#2977a7',
                                            'borderColor': '#2977a7',
                                        }}>
                                        {i18next.t('OK')}
                                    </button>
                                </div> 
                            </div>
                        </ModalBody>
                    </Modal>
                    : null
                }

            </React.Fragment>
        );
    }


    // Private
    _realodData(index) {
        this._getItems()
            .then(() => {
                if (index >= 0) {
                } else {
                    this.toggleCollapse(0);
                }
            });
    }

    _getItems() {
        this.setState({
            isLoading: true,
            showBackOfficeError: false
        });

        let filter = this._getFilter();

        return new Promise(resolve => {
            BackOfficeSerivce
                .getCancellations(filter)
                .then(data => {
                    this.setState({
                        data: data,
                        isLoading: false
                    }, resolve);
                })
                .catch((error) => {
                    this.setState({
                        showBackOfficeError: true,
                        isLoading: false
                    }, resolve);
                })

        });
    }

    _getFilter() {
        let filter = UtilsService.deepCopy(CancellationsStore.filter);
        filter.pageNumber = this.state.pageNumber;
        return filter;
    }
}
